<form [formGroup]="formGroup">
  <shared-form-field-wrapper label="Initial deposit" [formControl]="formGroup.controls.deposit">
    <shared-input-number type="currency" [formControl]="formGroup.controls.deposit" [min]="0" />
  </shared-form-field-wrapper>
  <shared-form-field-wrapper
    [label]="propertyPriceLabel"
    [formControl]="formGroup.controls.propertyPrice">
    <shared-input-number
      type="currency"
      [formControl]="formGroup.controls.propertyPrice"
      [min]="0" />
    <ng-container validation>
      <shared-validation-message [control]="formGroup.controls.propertyPrice">
        <div min-message>
          Has to be more or equal to initial deposit ({{
            formGroup.controls.propertyPrice.errors?.min?.min
              | currency: "GBP" : "symbol" : "1.0-0"
          }})
        </div>
      </shared-validation-message>
    </ng-container>
  </shared-form-field-wrapper>
  <div class="two-fields-form-row">
    <shared-form-field-wrapper
      label="What's your age?"
      [formControl]="formGroup.controls.ageInYears">
      <shared-input-number
        type="plain-number"
        [formControl]="formGroup.controls.ageInYears"
        [min]="18" />
      <ng-container validation>
        <shared-validation-message [control]="formGroup.controls.ageInYears">
          <div max-message>Maximum is 60</div>
        </shared-validation-message>
      </ng-container>
    </shared-form-field-wrapper>
    <shared-form-field-wrapper
      label="Max term length"
      [formControl]="formGroup.controls.newTermInMonths">
      <shared-input-term
        [formControl]="formGroup.controls.newTermInMonths"
        [maxYears]="MAX_MORTGAGE_DURATION_IN_MONTHS / 12"
        [shortPlaceholder]="(size$ | async) === ScreenSizeBreakpointNames.MOBILE" />
    </shared-form-field-wrapper>
  </div>
  @if (isMaxTermLimited) {
    <shared-warning headline="Notice">
      The maximum term you qualify for might be affected by your age. Many lenders have age limits
      in place to ensure the mortgage is repaid by a certain time.
    </shared-warning>
  }
  <!--  <div class="note" *ngIf="isMaxTermLimited">-->
  <!--    <shared-icon icon="info" width="1.5rem" height="1.5rem" />-->
  <!--    <div>-->
  <!--      The maximum term you qualify for might be affected by your age. Many lenders have age limits-->
  <!--      in place to ensure the mortgage is repaid by a certain time.-->
  <!--    </div>-->
  <!--  </div>-->
</form>
